import script from "./RewardCardPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardCardPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./RewardCardPlaceholder.vue?vue&type=style&index=0&id=5dc5c15f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc5c15f"]])

export default __exports__